import { render, staticRenderFns } from "./HelloDetails.vue?vue&type=template&id=362d3b48&scoped=true&"
import script from "./HelloDetails.vue?vue&type=script&lang=js&"
export * from "./HelloDetails.vue?vue&type=script&lang=js&"
import style0 from "./HelloDetails.vue?vue&type=style&index=0&id=362d3b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d3b48",
  null
  
)

export default component.exports